import AuthSplitLayout from 'layouts/AuthSplitLayout';
import bg from 'assets/img/bg/highway.jpg';
import SignInForm from 'components/modules/auth/SignInForm';

const SignIn = () => {
  return (
    <AuthSplitLayout bg={bg}>
      <SignInForm layout="split" />
    </AuthSplitLayout>
  );
};

export default SignIn;
